
import {useEffect} from "react";
import useScript from "../hooks/useScript";
import {GA_TRACKING_ID} from "../config";

function initGaFunction () {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag
    gtag('js', new Date());

    gtag('config', GA_TRACKING_ID);
    console.info('gtag: ', gtag)
}

export const useGaTag = () => {
    const status = useScript(
        "https://www.googletagmanager.com/gtag/js?id="+ GA_TRACKING_ID
    )
    return useEffect(() => {
        if (status == 'ready') {
            initGaFunction()
        }

    }, [ status ])
}